import { render, staticRenderFns } from "./SidebarFilterButton.vue?vue&type=template&id=57d09542&"
import script from "./SidebarFilterButton.vue?vue&type=script&lang=js&"
export * from "./SidebarFilterButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports